var timerSeconds = 3;
var timerCurrent = 0;
var timerFinish, timer;

export default function timer() {
    timerFinish = new Date().getTime()+(timerSeconds*1000);
    timer = setInterval(stopWatch,50);
}

function stopWatch() {

    var seconds = (timerFinish-(new Date().getTime()))/1000;

    if (seconds <= 0) {
        drawTimer(100);
        clearInterval(timer);
        $('input[type=button]#watch').val('Start');
    } else {
        var percent = 100-((seconds/timerSeconds)*100);
        drawTimer(percent);
    }
}

function drawTimer(percent) {

    $('div.timer').html('<div class="percent"></div><div id="slice"'+(percent > 50?' class="gt50"':'')+'><div class="pie"></div>'+(percent > 50?'<div class="pie fill"></div>':'')+'</div>');

    var deg = 360/100*percent;

    $('#slice .pie').css({
        '-moz-transform':'rotate('+deg+'deg)',
        '-webkit-transform':'rotate('+deg+'deg)',
        '-o-transform':'rotate('+deg+'deg)',
        'transform':'rotate('+deg+'deg)'
    });

}


// WEBPACK FOOTER //
// ./src/Resources/ui/js/timer.js